import React, { useCallback, useMemo, useState } from 'react';
import { Box, ErrorMessage, Inscription, PencilIcon } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { Vendor } from '@/modules/employer/components/Lockbox/queries/useGetVendors.query';

import EditCheckAddressModal from './EditCheckAddressModal';

const VENDOR_ERRORS = [
  LockboxValidationError.VENDOR_REQUIRED,
  LockboxValidationError.VENDOR_NAME_REQUIRED,
  LockboxValidationError.BENEFIT_OF_REQUIRED,
  LockboxValidationError.ADDRESS_LINE_1_REQUIRED,
  LockboxValidationError.CITY_REQUIRED,
  LockboxValidationError.STATE_REQUIRED,
  LockboxValidationError.ZIP_REQUIRED,
];

interface Props {
  checkDetailsAddress?: string;
  checkDetails?: Vendor;
}

const LockboxVendorAddress: React.FC<Props> = ({ checkDetailsAddress, checkDetails }) => {
  const [isEditCheckAddressModalVisible, setIsEditCheckAddressModalVisible] = useState(false);
  const { validationErrors } = useLockboxDetailsStore();

  const handleOpenEditAddressModal = useCallback(() => {
    setIsEditCheckAddressModalVisible(!isEditCheckAddressModalVisible);
  }, [isEditCheckAddressModalVisible]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => VENDOR_ERRORS.includes(error)) as LockboxValidationError | undefined;
  }, [validationErrors]);

  return (
    <>
      <Box data-testId="lockbox-vendor-address" margin={{ left: 'spacing8' }} direction="column">
        <Inscription color="textBody" weight={700}>
          {checkDetailsAddress || EMPTY_FIELD_VALUE}
          <PencilIcon
            size="spacing16"
            color="iconSecondary"
            onClick={handleOpenEditAddressModal}
            style={{
              marginLeft: '8px',
              marginBottom: '4px',
              verticalAlign: 'middle',
              cursor: 'pointer',
            }}
          />
        </Inscription>
        {errorType && <ErrorMessage errorText={lockboxValidationErrorTitle?.[errorType]} />}
      </Box>
    
      {isEditCheckAddressModalVisible && (
        <EditCheckAddressModal
          checkDetails={checkDetails}
          onSetVisible={handleOpenEditAddressModal}
        />
      )}
    </>
  );
};

export default LockboxVendorAddress;
